import { defineStore } from "pinia";
import { DefaultService } from "~~/api/njorda";

export const useUserStore = defineStore("user", {
    state: () => ({
        id: undefined as string | undefined,
        firstName: undefined as string | undefined,
        lastName: undefined as string | undefined,
        email: undefined as string | undefined,
        isEmailVerified: undefined as boolean | undefined,
        alreadyExistsWhenRegistering: false,
        termsAcceptedAt: undefined as Date | undefined,
        intercomJwtToken: undefined as string | undefined,
    }),

    getters: {
        name: (state) => [state.firstName, state.lastName].filter((n) => !!n).join(" "),
        isActiveUser(state) {
            return !!state.termsAcceptedAt;
        },
        exists: (state) => !!state.id,
    },

    actions: {
        setUser(userData: {
            id?: string;
            firstName?: string;
            lastName?: string;
            email?: string;
            isEmailVerified?: boolean;
            termsAcceptedAt?: Date;
            intercomJwtToken?: string;
        }) {
            this.id = userData.id;
            this.firstName = userData.firstName;
            this.lastName = userData.lastName;
            this.email = userData.email;
            this.isEmailVerified = userData.isEmailVerified;
            this.termsAcceptedAt = userData.termsAcceptedAt;
            this.intercomJwtToken = userData.intercomJwtToken;
        },
        clear() {
            const { clearCache: clearApiCache } = useNjordaApi();
            clearApiCache();

            this.id = undefined;
            this.firstName = undefined;
            this.lastName = undefined;
            this.email = undefined;
            this.isEmailVerified = undefined;
            this.termsAcceptedAt = undefined;
            this.intercomJwtToken = undefined;
        },
        updateUser(approveTerms = false) {
            const { api } = useNjordaApi();
            const body: {
                first_name?: string;
                last_name?: string;
                email?: string;
                accept_terms_conditions?: boolean;
            } = {
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
            };
            if (approveTerms) {
                body.accept_terms_conditions = true;
            }
            return api.patchAppV1AuthMe(body);
        },
        setAlreadyExistsWhenRegistering(flag: boolean) {
            this.alreadyExistsWhenRegistering = flag;
        },

        // actions
        fetchMe() {
            return DefaultService.getAppV1AuthMe().then((user) => {
                if (user) {
                    this.setUser({
                        id: user.id || "no id",
                        firstName: user.first_name,
                        lastName: user.last_name,
                        email: user.email,
                        isEmailVerified: user.is_email_verified,
                        termsAcceptedAt: user.terms_conditions_accepted_at
                            ? new Date(user.terms_conditions_accepted_at)
                            : undefined,
                        intercomJwtToken: user.intercom_jwt_token,
                    });
                }
                return user;
            });
        }
    },
});
